export default __webpack_public_path__ + "static/media/FINAL LOGO.9775b9b5.jpg";